import { invoiceFacteurClient } from './client'
import type { ServiceConfigParam, InvoiceFacteurAuditLog, Invoice } from '../types'

export const getInvoiceFacteurConfig = () =>
  invoiceFacteurClient.get<ServiceConfigParam[]>('/config')

export const setInvoiceFacteurConfig = (key: string, value: string) =>
  invoiceFacteurClient.post('/config', { [key]: value })

export const revealInvoiceFacteurConfig = (key: string) =>
  invoiceFacteurClient.get<{ value: string }>(`/config/${key}/reveal`)

// ── Audit logs ────────────────────────────────────────────────────────────────
export const getInvoiceFacteurAuditLogs = (params?: { action?: string; invoiceId?: string; limit?: number }) =>
  invoiceFacteurClient.get<InvoiceFacteurAuditLog[]>('/audit-logs', { params })

// ── Invoices ──────────────────────────────────────────────────────────────────
export const getInvoices = (params?: { status?: string; limit?: number }) =>
  invoiceFacteurClient.get<Invoice[]>('/invoices', { params })
